Controller.$inject = ['$element'];

function Controller($element) {
    const self = this;

    self.$onInit = function() {
        const trElement = $element[0];
        trElement.addEventListener('cellExpandClick', function() {
            if (self.onRowExpand) {
                self.onRowExpand();
            }
        });
    };
}

export function HuiTrGroup() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            deleted: '<',
            highlighted: '<',
            isFooter: '<',
            expanded: '<',
            loading: '<',
            hasExpanded: '<',
            isHeader: '<',
            onRowExpand: '&'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <tr class="is-grouped has-expanded" 
                   ng-class="[
                        !!$huiCtrl.deleted ? 'deleted' : '',
                        !!$huiCtrl.highlighted ? 'highlighted' : '',
                        !!$huiCtrl.isFooter ? 'footer' : '',
                        !!$huiCtrl.isHeader ? 'is-header' : '',
                        !!$huiCtrl.hasExpanded && $huiCtrl.expanded === false ? 'row-closed' : '',
                        !!$huiCtrl.hasExpanded && $huiCtrl.expanded === true ? 'row-expanded' : '',
                        !!$huiCtrl.hasExpanded && !!$huiCtrl.loading ? 'loading' : ''
                   ]"
                   ng-transclude>
            </tr>
            `;
        }
    };
}



